import { ClientType } from '../apollo'
import { MutationResult, types } from '../types'

import { deleteOneProfile } from '@dinosband/bv-main-schema/dist/client-gql'

export async function deleteProfile (client: ClientType, id: number): Promise<types.Profile | undefined | null> {
  try {
    const result = await client.mutate({
      mutation: deleteOneProfile,
      variables: {
        where: { id },
      } as types.MutationDeleteOneProfileArgs,
    }) as MutationResult
    return result.data.deleteOneProfile
  } catch (e) {
  }
}
